import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useDispatch, useSelector } from 'react-redux';
import clientApi from '~/clientApi';
import { fetchTalentManager } from '~/ducks/talent-manager';
import { MANAGER_ENTITY_QUERY_KEY } from '~/queries/keys';
import { selectTalentManager } from '~/selectors/talent-manager';

export const useUpdateManagersEnabledControls = () => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();

  const manager = useSelector(selectTalentManager);

  const mutation = useMutation({
    mutationFn: (enabledControls: string[]) => {
      return clientApi.managers.update({
        id: manager.id,
        enabledControls,
      });
    },
    onSuccess: async () => {
      queryClient.invalidateQueries([MANAGER_ENTITY_QUERY_KEY]);
      const updatedManager = await clientApi.managers.read(manager.id);
      return dispatch((fetchTalentManager as any).fulfilled(updatedManager));
    },
  });

  return mutation;
};
